<template>
  <div class="tab">
    <div>
      <span @click="returnFun()">＜返回</span>
      <p style="font-size: 14px;text-align: right;color:#777">原创： 虾仁 学业坚韧性项目组 2017-12-09</p>
      <div
        class="rich_media_content"
        id="js_content"
        style="max-width: 677px;margin-left: auto;margin-right: auto;"
      >
        <section powered-by="xiumi.us" style="box-sizing: border-box;">
          <section style="box-sizing: border-box;">
            <section style="box-sizing: border-box;">
              <p style="margin: 0px; padding: 0px; box-sizing: border-box;">
                <br style="box-sizing: border-box;" />
              </p>
            </section>
          </section>
        </section>

        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <p
              style="max-width: 100%;box-sizing: border-box;min-height: 1em;line-height: 2em;word-wrap: break-word !important;"
            >
              &nbsp; &nbsp; &nbsp;
              &nbsp;近期有一部动画片引起了大家的热议，那就是美国迪士尼公司皮克斯动画工作室出品的《寻梦环游记》。该片的主人公是一个叫米格的小男孩，他一心梦想成为一名音乐家，但是他的家人却对此明令禁止，他们认为米格应该继承发扬家族制鞋产业。怀揣梦想的米格想向自己的偶像——歌神德拉库斯致敬，他偷跑出去参加歌唱大赛，但是被家人发现。他的奶奶采取暴力拒绝的方式，并且敲碎了他心爱的吉他，来破碎米格的音乐梦想。对此，伤心的米格选择愤然离家来回应家人的不理解。
              <img
                class
                data-ratio="0.562"
                data-w="500"
                style="text-align: center; box-sizing: border-box; vertical-align: middle; overflow-wrap: break-word !important; visibility: visible !important; width: auto !important; height: auto !important;"
                _width="auto"
                src="../../assets/growthThinking/list6/640.png"
                crossorigin="anonymous"
                data-fail="0"
              />
            </p>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;text-align: justify;font-size: 15px;word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;line-height: 2em;word-wrap: break-word !important;"
              >
                &nbsp; &nbsp; &nbsp; &nbsp;
                <span
                  style="letter-spacing: normal;"
                >一边是孩子的梦想，一边是父母的期待，两者该如何抉择？这也许是每个家庭都曾遇到的问题，即孩子的意愿与父母的希望不相一致时，该如何进行选择？如何找到两者之间的平衡点？家长如果采取强硬的压制处理方式，很有可能导致孩子产生更加极端的行为，越压迫越反抗，这个时候家长该如何做？</span>
              </p>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="margin-top: 20px;margin-bottom: 10px;max-width: 100%;box-sizing: border-box;text-align: center;line-height: 0.8;font-size: 21px;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;width: 0px;display: inline-block;border-top: 0.8em solid rgb(163, 211, 188);word-wrap: break-word !important;border-left: 0.7em solid transparent !important;border-right: 0.7em solid transparent !important;"
            ></section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="margin-top: 10px;max-width: 100%;box-sizing: border-box;text-align: center;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;display: inline-block;word-wrap: break-word !important;"
            >
              <section
                style="margin-top: 0.5em;margin-right: 5px;max-width: 100%;box-sizing: border-box;width: 0.7em;height: 0.7em;display: inline-block;vertical-align: top;background-color: rgb(146, 202, 191);word-wrap: break-word !important;"
              ></section>
              <section
                class
                style="max-width: 100%;box-sizing: border-box;display: inline-block;vertical-align: top;word-wrap: break-word !important;"
              >
                <p
                  style="max-width: 100%;box-sizing: border-box;min-height: 1em;word-wrap: break-word !important;"
                >
                  <strong
                    style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
                  >
                    Step
                    1
                  </strong>
                </p>
              </section>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="margin-bottom: 20px;max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;color: rgb(103, 175, 122);word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;text-align: center;line-height: 2em;word-wrap: break-word !important;"
              >
                <strong
                  style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
                >第一步，了解孩子的梦想</strong>
              </p>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;text-align: justify;font-size: 15px;word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;line-height: 2em;word-wrap: break-word !important;"
              >
                &nbsp; &nbsp; &nbsp;
                &nbsp;家长在制止孩子的行为之前，可以先思考一下，自己是否确切的了解孩子到底想要做什么？电影中的奶奶以自己的期望出发，直接为米格规划了之后的人生。这样的做法没有充分尊重孩子的意愿，现实中父母应该给予孩子充分的发言权，让他们说出自己的想法后，家长再衡量接下来该如何应对。
              </p>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;text-align: center;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;display: inline-block;vertical-align: top;width: 330px;word-wrap: break-word !important;"
            >
              <section
                class
                powered-by="xiumi.us"
                style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
              >
                <section
                  class
                  style="margin-top: 10px;margin-bottom: 10px;max-width: 100%;box-sizing: border-box;transform: translate3d(0px, 0px, 0px);word-wrap: break-word !important;"
                >
                  <section
                    class
                    style="max-width: 100%;box-sizing: border-box;vertical-align: middle;display: inline-block;width: 323.391px;word-wrap: break-word !important;overflow: hidden !important;"
                  >
                    <img
                      data-ratio="0.7484375"
                      data-w="640"
                      width="100%"
                      style="box-sizing: border-box; background-color: rgb(238, 237, 235); border-width: 1px; border-style: solid; border-color: rgb(238, 237, 235); background-size: 22px; background-position: center center; background-repeat: no-repeat; vertical-align: middle; overflow-wrap: break-word !important; width: 315px !important; height: auto !important; visibility: visible !important;"
                      _width="315px"
                      src="../../assets/growthThinking/list6/640(1).png"
                      crossorigin="anonymous"
                      data-fail="0"
                    />
                  </section>
                </section>
              </section>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="margin-top: 10px;max-width: 100%;box-sizing: border-box;text-align: center;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;display: inline-block;word-wrap: break-word !important;"
            >
              <section
                style="margin-top: 0.5em;margin-right: 5px;max-width: 100%;box-sizing: border-box;width: 0.7em;height: 0.7em;display: inline-block;vertical-align: top;background-color: rgb(140, 170, 203);word-wrap: break-word !important;"
              ></section>
              <section
                class
                style="max-width: 100%;box-sizing: border-box;display: inline-block;vertical-align: top;word-wrap: break-word !important;"
              >
                <p
                  style="max-width: 100%;box-sizing: border-box;min-height: 1em;word-wrap: break-word !important;"
                >
                  <strong
                    style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
                  >
                    Step
                    2
                  </strong>
                </p>
              </section>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="margin-bottom: 20px;max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;text-align: center;color: rgb(46, 91, 135);word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;word-wrap: break-word !important;"
              >
                <strong
                  style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
                >第二步，尊重孩子的梦想</strong>
              </p>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;text-align: justify;font-size: 15px;word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;line-height: 2em;word-wrap: break-word !important;"
              >
                &nbsp; &nbsp; &nbsp;
                &nbsp;孩子的梦想是需要守护的。梦想对于孩子而言就像远方的灯塔一样，指引着孩子成为更加优秀的人。电影中的主人公米格的兴趣与热情在于音乐，而最初他的家人在他还未尝试前，就直接打破他的梦想，让他做自己不想做的事情。其实兴趣和热情是坚毅必不可少的部分。与其要求孩子对父母规划好的路线产生兴趣，不如让孩子试着走走自己已经有兴趣的路。
              </p>
            </section>
          </section>
        </section>
        <p
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;line-height: 2em;word-wrap: break-word !important;text-align: center;"
        >
          <br />
        </p>
        <section
          class
          style="max-width: 100%;box-sizing: border-box;vertical-align: middle;display: inline-block;word-wrap: break-word !important;overflow: hidden !important;"
        >
          <p>
            <img
              data-ratio="0.40625"
              data-w="640"
              style="box-sizing: border-box; background-color: rgb(238, 237, 235); border-width: 1px; border-style: solid; border-color: rgb(238, 237, 235); background-size: 22px; background-position: center center; background-repeat: no-repeat; vertical-align: middle; overflow-wrap: break-word !important; width: 507px !important; height: auto !important; visibility: visible !important;"
              _width="507px"
              src="../../assets/growthThinking/list6/640(2).png"
              crossorigin="anonymous"
              data-fail="0"
            />
          </p>
          <p>
            <br />
          </p>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;text-align: center;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;display: inline-block;word-wrap: break-word !important;"
          >
            <section
              style="margin-top: 0.5em;margin-right: 5px;max-width: 100%;box-sizing: border-box;width: 0.7em;height: 0.7em;display: inline-block;vertical-align: top;background-color: rgb(238, 201, 213);word-wrap: break-word !important;"
            ></section>
            <section
              class
              style="max-width: 100%;box-sizing: border-box;display: inline-block;vertical-align: top;word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;word-wrap: break-word !important;"
              >
                <strong
                  style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
                >
                  Step
                  3
                </strong>
              </p>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="margin-bottom: 20px;max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;text-align: center;color: rgb(216, 73, 107);word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;line-height: 2em;word-wrap: break-word !important;"
              >
                <strong
                  style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
                >第三步，接纳孩子的梦想</strong>
              </p>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;text-align: justify;font-size: 15px;word-wrap: break-word !important;"
            >
              <p
                style="max-width: 100%;box-sizing: border-box;min-height: 1em;line-height: 2em;word-wrap: break-word !important;"
              >
                &nbsp; &nbsp; &nbsp;
                孩子的梦想有的时候会存在一些不成熟的地方，这个时候家长应该以成长型思维模式的视角去应对。在适度的范围内鼓励孩子去尝试，即使失败也是一次宝贵经验累积的过程。孩子如果失败了，家长切不可在一旁说“风凉话”，例如“你看，我早就说这样子不行了吧，你就是不听！”等。这种话语会极大地挫伤孩子的自尊心，使得他们渐渐丧失挑战、尝试的勇气。父母应该以更积极的方式来应对孩子的失败，告诉孩子“没有关系”，并且询问孩子是否愿意听听父母的意见。
              </p>
            </section>
          </section>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="max-width: 100%;box-sizing: border-box;vertical-align: middle;display: inline-block;word-wrap: break-word !important;overflow: hidden !important;"
          >
            <img
              data-ratio="0.5555556"
              data-w="540"
              cla
              style="box-sizing: border-box; background-color: rgb(238, 237, 235); border-width: 1px; border-style: solid; border-color: rgb(238, 237, 235); background-size: 22px; background-position: center center; background-repeat: no-repeat; vertical-align: middle; overflow-wrap: break-word !important; width: 540px !important; height: 300.889px !important;"
              _width="540px"
              src="../../assets/growthThinking/list6/640(3).png"
              crossorigin="anonymous"
            />
          </section>
          <p style="line-height: 2em;">
            <span style="font-size: 15px;text-align: justify;">
              &nbsp;
              &nbsp; &nbsp;
              &nbsp;以上，是小编观看电影后的一点想法。《寻梦环游记》是一部“合家欢”电影，以家庭亲情作为情感主线，有爱有梦想，推荐各位家长带领孩子一同观看~
            </span>
            <br />
          </p>
        </section>
        <section
          class
          powered-by="xiumi.us"
          style="max-width: 100%;box-sizing: border-box;color: rgb(62, 62, 62);font-size: 16px;white-space: normal;word-wrap: break-word !important;"
        >
          <section
            class
            style="margin-top: 6px;margin-bottom: 20px;max-width: 100%;box-sizing: border-box;word-wrap: break-word !important;"
          >
            <section
              class
              style="max-width: 100%;box-sizing: border-box;border-top: 4px solid rgb(236, 189, 172);word-wrap: break-word !important;"
            ></section>
            <section
              class
              style="margin-top: 3px;max-width: 100%;box-sizing: border-box;border-top: 1px solid rgb(236, 189, 172);word-wrap: break-word !important;"
            ></section>
          </section>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "list3",
  data() {
    return {};
  },
  props: ["listOrCon"],
   methods:{
    returnFun(){
      this.$emit("returnPage")
    }
  }
};
</script>
<style scoped>
.tab > div > span{
  cursor: pointer;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 5px;
  color: #7ecef4;
  border: solid 1px #7ecef4
}
.rich_media_content {
  overflow: hidden;
  color: #333;
  font-size: 17px;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  text-align: justify;
  position: relative;
  z-index: 0;
}

.rich_media_content * {
  max-width: 100% !important;
  box-sizing: border-box !important;
  -webkit-box-sizing: border-box !important;
  word-wrap: break-word !important;
}

.rich_media_content p {
  clear: both;
  min-height: 1em;
}

.rich_media_content em {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/growthThinking/list6.vue